/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { group_combinations_GroupCombinationListResponse } from '../models/group_combinations_GroupCombinationListResponse';
import type { group_combinations_GroupCombinationRequest } from '../models/group_combinations_GroupCombinationRequest';
import type { group_combinations_GroupCombinationResponse } from '../models/group_combinations_GroupCombinationResponse';
import type { group_combinations_GroupCombinationSuggestionListResponse } from '../models/group_combinations_GroupCombinationSuggestionListResponse';
import type { group_combinations_UpdateGroupCombinationRequest } from '../models/group_combinations_UpdateGroupCombinationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupCombinationsService {
    /**
     * List group combinations
     * Weekly group combinations whose validity intersects [from, to], with their
     * joining groups. from and to are required and at most 62 days apart.
     * @param from Range start (YYYY-MM-DD)
     * @param to Range end (YYYY-MM-DD)
     * @returns group_combinations_GroupCombinationListResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupCombinations(
        from: string,
        to: string,
    ): CancelablePromise<group_combinations_GroupCombinationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/group-combinations',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Missing or invalid range`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list group combinations`,
            },
        });
    }
    /**
     * Create a group combination
     * Creates a weekly group combination. All groups must belong to one childcare.
     * A group can be in at most one combination for any slot; an overlap returns 409
     * with the message "group <name> is already combined on <weekdays> <start>-<end>".
     * Capacity is not checked; the slot coverage flags over_capacity.
     * @param request Combination
     * @returns group_combinations_GroupCombinationResponse Created
     * @throws ApiError
     */
    public static postApiV1GroupCombinations(
        request: group_combinations_GroupCombinationRequest,
    ): CancelablePromise<group_combinations_GroupCombinationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/group-combinations',
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Capacity module required, or organization ID not found in token`,
                409: `A group is already combined in an overlapping window`,
                500: `Failed to create group combination`,
            },
        });
    }
    /**
     * Delete a group combination
     * Soft-deletes a group combination and its joining groups.
     * @param id Combination ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1GroupCombinations(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/group-combinations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid combination ID`,
                401: `Authentication required`,
                403: `Capacity module required, or organization ID not found in token`,
                404: `Group combination not found`,
                500: `Failed to delete group combination`,
            },
        });
    }
    /**
     * Update a group combination
     * Replaces a group combination with optimistic locking on current_updated_at.
     * Same rules as create. A stale current_updated_at returns 409.
     * @param id Combination ID
     * @param request Combination
     * @returns group_combinations_GroupCombinationResponse OK
     * @throws ApiError
     */
    public static putApiV1GroupCombinations(
        id: string,
        request: group_combinations_UpdateGroupCombinationRequest,
    ): CancelablePromise<group_combinations_GroupCombinationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/group-combinations/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Capacity module required, or organization ID not found in token`,
                404: `Group combination not found`,
                409: `Overlap, or modified by another user`,
                500: `Failed to update group combination`,
            },
        });
    }
    /**
     * Suggest group combinations
     * Combinations of the groups of one childcare that would save staff. The planned
     * slot coverage of 4 weeks from a Monday is computed as if no combination existed.
     * A slot qualifies when the unit saves at least one staff and stays within the host
     * capacity on at least 3 dates of a weekday. Per weekday the longest morning and
     * evening runs of at least 30 minutes are suggested; weekdays with the same window
     * are merged. Suggestions that overlap an existing combination are left out. At
     * most 10, ranked by staff saved x minutes x weekdays. Nothing is stored.
     * @param childcareId Childcare ID
     * @param from Monday the 4 weeks start on (YYYY-MM-DD), default the next Monday
     * @returns group_combinations_GroupCombinationSuggestionListResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupCombinationsSuggestions(
        childcareId: string,
        from?: string,
    ): CancelablePromise<group_combinations_GroupCombinationSuggestionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/group-combinations/suggestions',
            query: {
                'childcare_id': childcareId,
                'from': from,
            },
            errors: {
                400: `Missing childcare_id, or from is not a Monday`,
                401: `Authentication required`,
                403: `Capacity or shifts-absences module required, or organization ID not found in token`,
                500: `Failed to suggest group combinations`,
            },
        });
    }
}
